import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import smoothscroll from 'smoothscroll-polyfill';
import { ContentManager, ScriptRunnerImpl } from '../modules/chatbot';
import { v4 as uuidv4 } from 'uuid';
import { QuestionnaireResponse } from './questionnaire-response.model';
import { ChatbotHostService } from './chatbothost.service';
import { SymptommatrixComponent } from '../symptommatrix'

@Component({
    selector: 'app-chat-bot-host',
    templateUrl: "./chatbothost.component.html",
    styleUrls: ["./chatbothost.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ChatBotHostComponent implements OnInit {
    @Input() chatbotName: string = "";
    content: ContentManager;
    runner: ScriptRunnerImpl;
    questionnaireJSON: any = {};
    scriptJSON: any = {};
    questionnaireResponse: QuestionnaireResponse;

    constructor(private http: HttpClient,
        private cd: ChangeDetectorRef,
        private chatbotHostService: ChatbotHostService) { }

    ngOnInit(): void {
        if (this.chatbotName) {
           this.getServerChatBotDetail();
        } else {
           this.getStaticChatbotDetail("Copeia");
        }
        this.fnScrollTop();
    }

    fnScrollTop() {
        const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
        if (isIEOrEdge) {
            smoothscroll.polyfill();
            window.scrollTo(0, 0);
        } else {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    }

    loadQuestionnaireJSON(chatBotName) {
        this.chatbotHostService.getStaticQuestionnaire(chatBotName).subscribe(
            data => {
                this.questionnaireJSON = data;
                this.loadScriptJSON(chatBotName);
            })
    }

    loadScriptJSON(chatBotName) {
        this.chatbotHostService.getStaticScript(chatBotName).subscribe(
            data => {
                this.scriptJSON = data;
                this.beforeRunChatbot();
            })
    }

    getStaticChatbotDetail(chatBotName) {
        if (!chatBotName) {
            chatBotName = "Copeia";
        }
        chatBotName = chatBotName.toLowerCase();
        this.loadQuestionnaireJSON(chatBotName);
    }


    getServerChatBotDetail() {
        this.chatbotHostService.getChatBotDetail(this.chatbotName).subscribe(
            res => {
                if (res) {
                    this.questionnaireJSON = JSON.parse(res.Questionnaire);
                    this.scriptJSON = JSON.parse(res.Script);
                    this.beforeRunChatbot();
                } else {
                    this.getStaticChatbotDetail(this.chatbotName);
                }
            },
            err => {
                console.log(err)
                this.getStaticChatbotDetail(this.chatbotName);
            }
        )
    }

    generateDefaultQResponse() {
        this.questionnaireResponse = {
            resourceType: "QuestionnaireResponse",
            page: window.parent.location.href,
            identifier: uuidv4(),
            questionnaire: this.questionnaireJSON.identifier[0],
            status: 'in-progress',
            item: []
        }
    }

    getJSONItem(answerValueSet) {
        for (var i = 0; i < this.questionnaireJSON.item.length; i++) {
            const item = this.questionnaireJSON.item[i];
            if (item.answerValueSet === `#${answerValueSet}`) {
                return item;
            }
        }
        return null;
    }

    beforeRunChatbot() {
        this.generateDefaultQResponse();
        let record = {};
        let step = [];
        this.runChatbot(record, step);
    }

    reRunChatbot(index, records, steps) {
        this.questionnaireResponse.status = "in-progress";
        let items = this.questionnaireResponse.item;
        this.questionnaireResponse.item = [];
        let record = {};
        let step = [];
        for (var i = 0; i < steps.length; i++) {
            if (i < index) {
                let obj = steps[i];
                step.push(obj);
                record[obj.variable] = obj.response;

                let item = items.find(a => a.variable == obj.variable);
                if (item) {
                    this.questionnaireResponse.item.push(item);
                }
            }
        }
        this.saveResponseIntoDB();
        this.runChatbot(record, step);
    }

    runChatbot(record, step) {
        record["identifier"] = this.questionnaireResponse.identifier;
        this.content = new ContentManager();
        this.runner = new ScriptRunnerImpl(this.http, this.content, 'en');
        this.runner.registerCustomComponents([
            {
                keyword: 'symptommatrix',
                cls: SymptommatrixComponent
            }
        ]);

        let data = this.scriptJSON;
        const script = data.script;
        this.runner.timeout = data.timeout > 0 ? data.timeout : 1;
        this.runner.backButton = true;
        this.runner.run(
            script,
            0,
            {
                update_timeout: (params) => {
                    if (params) {
                        this.content.setQueueTimeout(params.timeout);
                    } else {
                        this.content.setQueueTimeout(100);
                    }
                },
                resetOnBackIndex: (index, records, steps) => {
                    this.reRunChatbot(index, records, steps);
                },
                save: (records) => {
                    //console.log("records", records);
                    setTimeout(() => {
                        this.questionnaireResponse.status = "completed";
                        this.saveResponseIntoDB();
                    }, 1000)
                }
            },
            (key, value, records) => {
                //console.log("key value records", key, value, records);
                const item = this.getJSONItem(key);
                if (item) {
                    this.questionnaireResponse.status = "in-progress";
                    var itemObj = {
                        linkId: item.linkId,
                        text: item.text,
                        variable: key,
                        response: JSON.stringify(value),
                        answer: {}
                    }

                    if (typeof value === "object") {
                        var list = [];
                        var objValue = Object.keys(value);
                        for (var objKey of objValue) {
                            if (value[objKey]) {
                                list.push(objKey);
                            }
                        }
                        list.sort();
                        itemObj.answer["valueOptions"] = list.join(",");
                    }
                    else if (typeof value === "boolean") {
                        itemObj.answer["valueBoolean"] = value;
                    } else {
                        itemObj.answer["valueString"] = value;
                    }

                    this.questionnaireResponse.item.push(itemObj)
                    this.saveResponseIntoDB();
                }
            },
            record,
            step
        ).subscribe((success) => {
            console.log('Reported device success', success);
        });
    }

    saveResponseIntoDB() {
        this.chatbotHostService.saveChatBotResponse(this.questionnaireResponse).subscribe();
    }
}
